import { useQuery } from "convex/react";

import { api } from "@convex/_generated/api";

/**
 * Subscribes to the authed user's full workflows library — every spec,
 * newest-first, each joined with its running-first `latestExecution`
 * (see `api.specs.listForUser`).
 *
 * `isLoading` is true only while the query is in flight (`undefined`);
 * an authed user with zero workflows resolves to `specs: []`.
 */
export function useSpecs() {
  const result = useQuery(api.specs.listForUser);
  return {
    specs: result ?? [],
    isLoading: result === undefined,
  };
}
